module.exports = __webpack_public_path__ + "img/ogre.fc036a57.png";